<template>
    <div class="d-flex flex-column overflow-hidden h-100">
        <vue-custom-scrollbar
            class="app-content-padding flex-grow-1 overflow-hidden h-100"
        >
            <ts-page-title
                :title="$t('bankProfile.pageTitle')"
                :breadcrumb="[
                    { text: $t('home'), href: '/' },
                    {
                        text: $t('bankProfile.pageTitle'),
                        href: '/admin/bank-profiles'
                    },
                    { text: $t('create'), active: true }
                ]"
            />
            <div class="demo-spin-article">
                <ts-panel>
                    <ts-panel-wrapper>
                        <form-input v-model="model" :validate="errors" />
                    </ts-panel-wrapper>
                </ts-panel>
            </div>
        </vue-custom-scrollbar>

        <Spin size="large" fix v-if="loading"></Spin>

        <div
            id="footer"
            class="app-footer m-0 tw-flex tw-justify-end tw-space-x-2"
            style="background-color: #e9ecef"
        >
            <ts-button
                @click.prevent="$router.push({ name: 'bank-profile' })"
                class="btn-gray"
            >
                {{ $t("cancel") }}
            </ts-button>
            <ts-button
                color="primary"
                :waiting="waiting"
                :disabled="waiting"
                @click.prevent="onSave"
            >
                {{ $t("save") }}
            </ts-button>
        </div>
    </div>
</template>

<script>
import AppOptions from "@/config/AppOptions.vue";
import { Errors } from "form-backend-validation";
import FormInput from "./components/form-input.vue";

export default {
    name: "BankProfileCreate",
    components: { FormInput },
    data() {
        return {
            loading: false,
            waiting: false,
            waiting_new: false,
            errors: new Errors(),
            model: {
                bank_name: "",
                accounts: []
            }
        };
    },
    created() {
        AppOptions.appContentFullHeight = true;
        AppOptions.appContentClass = "p-0";
    },
    methods: {
        async onSaveAddNew() {
            this.errors = new Errors();
            this.waiting_new = true;
            this.$store
                .dispatch("finance/bankProfile/store", this.model)
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                    if (response.message_id == 0) this.clearInput();
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => (this.waiting_new = false));
        },
        async onSave() {
            this.errors = new Errors();
            this.waiting = true;
            this.$store
                .dispatch("finance/bankProfile/store", this.model)
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                    if (response.message_id == 0) {
                        this.$router.push({ name: "bank-profile" });
                    }
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => (this.waiting = false));
        },
        clearInput() {
            this.model.bank_name = "";
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "BANK PROFILE",
                desc: not.text
            });
        }
    },
    beforeRouteLeave(to, from, next) {
        AppOptions.appContentFullHeight = false;
        AppOptions.appContentClass = "";
        next();
    }
};
</script>
